import React from 'react';
import './styles/home.scss';
import { FaTwitter, FaFacebookF, FaTiktok, FaInstagram } from 'react-icons/fa';

function Home() {
    return (
        <section className='home-section'>
            <div className='home-decorations'>
                <span>&#9702;</span>
                <span>&#9702;</span>
                <span>&#9702;</span>
                <span>&#9702;</span>
            </div>

            <aside
                className='home-image1'
                style={{
                    backgroundImage: `url('${process.env.PUBLIC_URL}/photo1.jpg')`,
                }}
            >
                <article className='description'>
                    <p>STERLING VASE INDIGO</p>
                    <p className='price'>$84.99</p>
                </article>
            </aside>
            <h1>
                MADE
                <br />
                FOR YOU
            </h1>
            <aside
                className='home-image2'
                style={{
                    backgroundImage: `url('${process.env.PUBLIC_URL}/photo2.jpg')`,
                }}
            >
                <article className='description'>
                    <p>LIVING ROOM DECOR COLLECTION</p>
                    <p className='price'>Start from $119.99</p>
                </article>
            </aside>

            <div className='social-icons-wrapper'>
                <FaTwitter className='social-icon' />
                <FaFacebookF className='social-icon' />
                <FaInstagram className='social-icon' />
                <FaTiktok className='social-icon' />
            </div>
        </section>
    );
}

export default Home;
